/* eslint-disable no-irregular-whitespace */
import { preloadImage } from '@mail/3promo';
import darkCover from 'img/extendQuotaOfferModal/desktop/dark.jpg';
import lightCover from 'img/extendQuotaOfferModal/desktop/light.jpg';
import darkCoverMobile from 'img/extendQuotaOfferModal/mobile/dark.jpg';
import lightCoverMobile from 'img/extendQuotaOfferModal/mobile/light.jpg';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Product } from 'reactApp/types/Billing';
import { getDiscount } from 'reactApp/utils/getDiscount';
import { getPeriodName } from 'reactApp/utils/Period';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { ExtendQuotaOfferModalProps } from './ExtendQuotaOfferModal.types';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderExtendQuotaOfferModal = ({ onClose, ...data }: ExtendQuotaOfferModalProps) => {
    openPopupHelper({
        popupName: popupNames.EXTEND_QUOTA_OFFER_MODAL,
        data,
        onClose,
    });
};

export const renderExtendQuotaOfferMobileModal = ({ onClose, ...data }: ExtendQuotaOfferModalProps) => {
    openPopupHelper({
        popupName: popupNames.EXTEND_QUOTA_OFFER_MOBILE_MODAL,
        data,
        onClose,
    });
};

export const getExtendQuotaOfferModalCoverImage = () => {
    const isDarkTheme = isDarkThemeModeEnabled();
    const isMobile = EnvironmentSelectors.isMobile();

    if (isMobile) {
        return isDarkTheme ? darkCoverMobile : lightCoverMobile;
    }

    return isDarkTheme ? darkCover : lightCover;
};

export const preloadExtentQuotaOfferCoverImage = async () => {
    const coverImageUrl = getExtendQuotaOfferModalCoverImage();
    await preloadImage({ src: coverImageUrl, timeout: IMAGE_PRELOAD_TIMEOUT });
};

export const getExtentQuotaOfferTitle = (isMobile: boolean, product: Product) => {
    const { hasDiscount, discountPrice, price, space, period } = product;

    if (!hasDiscount || !discountPrice) {
        return;
    }

    const value = space.value;
    const { discount } = discountPrice ? getDiscount({ discountPrice, price }) : { discount: 0 };
    const periodName = getPeriodName(period, false, true);

    if (isMobile) {
        return `Оплата тарифа ${value} на ${periodName} со скидкой ${discount}%`;
    }

    return `Подписка Mail Space на ${periodName} со скидкой`;
};
